var _metadata, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "370.000000pt",
    height: "242.000000pt",
    viewBox: "0 0 370.000000 242.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\r\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,242.000000) scale(0.100000,-0.100000)",
    fill: "red",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1230 1959 c-32 -13 -78 -56 -96 -91 -12 -22 -14 -132 -14 -642 0 -410 4 -624 11 -643 13 -34 55 -80 91 -99 40 -21 1256 -21 1296 0 36 19 78 65 91 99 7 18 11 154 11 373 l0 344 -85 0 -85 0 0 -330 0 -330 -580 0 -580 0 0 580 0 580 415 0 415 0 0 85 0 85 -432 -1 c-262 0 -443 -4 -458 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2145 1480 c-192 -192 -352 -350 -355 -350 -3 0 -63 55 -133 122 l-129 121 -56 -56 -57 -57 185 -185 185 -185 415 415 415 415 -55 55 c-30 30 -57 55 -60 55 -3 0 -163 -157 -355 -350z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.c9bc1906fc07cc9617202306a04836bd.svg";
export { ForwardRef as ReactComponent };